const { fetchAllWordpress } = require('../../../../utils/fetch-wp');
const postCategories = require('../../../../data/categories.json');
const fetchWordpress = require('../../../../api/wordpress');

async function getInitialProps(props) {
  const { category } = props;
  if (!category) return props;
  try {
    const { name: title } = await fetchWordpress(`categories/${category}`);
    const initialData = await fetchAllWordpress(`posts?categories=${category}`);

    const articles = initialData.map(data => {
      const { title, date, slug, categories, acf } = data;
      const { default_fields } = acf;
      return {
        ...default_fields,
        image: default_fields.featured_image && default_fields.featured_image.name,
        title: title.rendered,
        date,
        slug: `/${slug}`,
        categories: categories.map(cat => postCategories[cat].name)
      };
    });
    return {
      title,
      articles
    };
  } catch (e) {
    console.log('ERROR', e);
    return props;
  }
}

module.exports = {
  getInitialProps
};
